import script from "./DogsList.vue?vue&type=script&setup=true&lang=js"
export * from "./DogsList.vue?vue&type=script&setup=true&lang=js"

import "./DogsList.vue?vue&type=style&index=0&id=4cecf556&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cecf556"]])

export default __exports__